import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=01eb4a1c&scoped=true"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=01eb4a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb4a1c",
  null
  
)

export default component.exports